export default {
  items: [],
  cbs: [],
  loading: false,
  page: 1,
  ExportReportUrlXml: '',
  ExportReportUrlXlsx: '',
}